const isDev = typeof __DEV__ !== "undefined" && __DEV__;
const isFunction = (value) => typeof value === "function";
const isDefined = (value) => typeof value !== "undefined";
const isString = (value) => typeof value === "string";
const isObject = (value) => typeof value === "object" && !!value && value.toString() === "[object Object]";
const isNumber = (value) => typeof value === "number";
const isBoolean = (value) => typeof value === "boolean";
const isArray = Array.isArray;
export {
  isArray,
  isBoolean,
  isDefined,
  isDev,
  isFunction,
  isNumber,
  isObject,
  isString
};
